module.exports = __webpack_public_path__ + "static/img/cgpdt.045d48c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/cgpdt.png
// module id = S4+3
// module chunks = 0